import axios from "axios";

const MEDIA_ITEM_REST_URL = "/web/rest/media-item";

/**
 * Retrieve media item data based on given array of tags.
 */
export function getMediaItem(
  presentation,
  mediaItemType = "article",
  hideTitle = true,
  ...tags
) {
  return axios
    .post(MEDIA_ITEM_REST_URL, {
      presentation: presentation,
      mediaItemType: mediaItemType,
      hideTitle: hideTitle,
      tags: tags
    })
    .then(response => response.data);
}

/**
 * Retrieve media item meta data info based on given array of tags.
 */
export function getMediaItemInfo(presentation, ...tags) {
  const commaSeparatedTags = (tags || []).join(",");
  return axios
    .get(
      `${MEDIA_ITEM_REST_URL}/info?type=${presentation}&tags=${commaSeparatedTags}`
    )
    .then(response => response.data);
}
